import React, { useEffect, useState, useMemo } from 'react';
import
  {
    Container,
    Grid,
    Card,
    CardContent,
    Typography,
    CardMedia,
    Box,
    LinearProgress,
    Paper,
    TextField,
    FormControl,
    Select,
    MenuItem,
    List,
    ListItem,
    ListItemText,
    Divider,
    Button,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Pagination,
    Collapse,
    useMediaQuery,
    useTheme,
    Chip,
    FormGroup,
    FormControlLabel,
    Tooltip,
    ListItemButton,
  } from '@mui/material';
import instance from '../utils/axiosConfig.js';
import moment from 'moment';
import 'moment/locale/es';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DeleteSweep, Close as CloseIcon, ExpandMore as ExpandMoreIcon, LocationOn as LocationOnIcon, DeleteSweep as DeleteSweepIcon, Verified as VerifiedIcon, Search as SearchIcon } from '@mui/icons-material';
import styled from '@emotion/styled';
import banner from '../assets/liderdistbanner2.webp'; // Adjust path as needed
import { getCachedImage } from '../utils/imageCache';
import { CATEGORY_HIERARCHY } from '../constants/categories';
import LoadingScreen from '../components/LoadingScreen';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FeaturedProductsSlideshow from '../components/FeaturedProductsSlideshow';
import { LOCATIONS, getProvinces, getCities } from '../constants/locations';
import LdPlaceHolder from '../assets/ldplaceholder.png';
import {UNIT_LABELS_SINGULAR, UNIT_LABELS_PLURAL} from '../utils/units.js';
import { Helmet } from 'react-helmet';
import QuickAccessToolbar from '../components/QuickAccessToolbar';

const ExpandIcon = styled(({ expand, ...other }) => <IconButton {...other}>
  <ExpandMoreIcon />
</IconButton>)(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

// // Add these constants at the top of the file
// const UNIT_LABELS_SINGULAR = {
//   'unidad': 'unidad',
//   'kg': 'kg',
//   'lt': 'litro',
//   'm2': 'metro cuadrado',
//   'mt': 'metro',
//   'cm': 'centímetro',
//   'docena': 'docena',
//   'caja': 'caja',
//   'pack': 'pack',
//   'hectarea': 'hectárea'
// };

// const UNIT_LABELS_PLURAL = {
//   'unidad': 'unidades',
//   'kg': 'kilogramos',
//   'lt': 'litros',
//   'm2': 'metros cuadrados',
//   'mt': 'metros',
//   'cm': 'centímetros',
//   'docena': 'docenas',
//   'caja': 'cajas',
//   'pack': 'packs',
//   'hectarea': 'hectáreas'
// };

// Update the PriceDisplay component
const PriceDisplay = ({ basePrice, priceBreaks, hidePrice, unit, isMobile }) =>
{
  if (hidePrice)
  {
    return <Typography variant="subtitle1" color="text.secondary">Consultar precio</Typography>;
  }

  // Get the lowest price from the last price break, if it exists and is lower than base price
  const lowestPriceBreak = priceBreaks?.length > 0 ? priceBreaks[priceBreaks.length - 1] : null;
  const displayPrice = lowestPriceBreak && lowestPriceBreak.price < basePrice
    ? { price: lowestPriceBreak.price, quantity: lowestPriceBreak.minQuantity }
    : { price: basePrice, quantity: null };

  if (isMobile) {
    return (
      <Box sx={{ my: {xs:0, md:0.5} }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="h5" color="#282828" sx={{ display: 'block',fontFamily: 'Roboto', fontSize: {xs: '1.25rem'} }}>
          ${displayPrice.price.toLocaleString()}
          </Typography>
          <span variant="h5" color="#282828" sx={{ display: 'block',fontFamily: 'Roboto', fontSize: {xs: '0.85rem'} }}>
            por {unit ? unit : "unidad"}
          </span>
          </Box>
          <Typography variant="body1" textAlign="left" color="#282828" sx={{  fontSize: {xs: '1rem'} }}>
          {displayPrice.quantity && (
            <Box component="span" sx={{
              fontSize: '0.8em',
              color: 'success.main',
            }}>
            ({displayPrice.quantity}+ {UNIT_LABELS_PLURAL[unit] ? UNIT_LABELS_PLURAL[unit] : "unidades"})
            </Box>
          )}
        </Typography>
        <Divider sx={{ my: 1 , width:'100%', color:'#282828',height:1, borderColor: 'rgba(0,0,0,0.1)'}} />
        {priceBreaks?.length > 0 && (
          
          <Box sx={{ mt: 0.5 }}>
           {!isMobile && 
            <Box>
              <Divider sx={{ my: 1 , color:'#282828',height:1, borderColor: 'rgba(0,0,0,0.1)'}} />
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              Otros precios por volumen:
            </Typography>
            </Box>
            }
            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              mt: 0.5
            }}>
              {priceBreaks
                .slice(0, -1) // Exclude the last price break if it's being shown as main price
                .map((break_, index) => (
                  <Chip
                    key={index}
                    size="small"
                    label={`${break_.minQuantity}+ ${UNIT_LABELS_PLURAL[unit] ? UNIT_LABELS_PLURAL[unit] : "unidades"}: $${break_.price.toLocaleString()} por ${unit ? unit : "unidad"}`}
                    sx={{
                      backgroundColor: 'rgba(29, 63, 85, 0.55)',
                      borderRadius: '2px',
                      color: 'white',
                      py:1,
                      fontWeight: 600,
                      fontSize: '0.8rem'
                    }}
                  />
                ))}
            </Box>
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#424242' }}>
        ${displayPrice.price.toLocaleString()} por {unit ? unit : "unidad"}
        {displayPrice.quantity && (
          <Box component="span" sx={{
            fontSize: '0.8em',
            color: 'success.main',
            ml: 1
          }}>
            <br></br>({displayPrice.quantity}+ {UNIT_LABELS_PLURAL[unit] ? UNIT_LABELS_PLURAL[unit] : "unidades"})
          </Box>
        )}
      </Typography>
      {priceBreaks?.length > 0 && (
          <Box sx={{ mt: 0.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              Otros precios por volumen:
            </Typography>
            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              mt: 0.5
            }}>
              {priceBreaks
                .slice(0, -1) // Exclude the last price break if it's being shown as main price
                .map((break_, index) => (
                  <Chip
                    key={index}
                    size="small"
                    label={`${break_.minQuantity}+ ${UNIT_LABELS_PLURAL[unit] ? UNIT_LABELS_PLURAL[unit] : "unidades"}: $${break_.price.toLocaleString()} por ${unit ? unit : "unidad"}`}
                    sx={{
                      backgroundColor: 'rgba(29, 63, 85, 0.55)',
                      borderRadius: '2px',
                      color: 'white',
                      py:1,
                      fontWeight: 600,
                      fontSize: '0.8rem'
                    }}
                  />
                ))}
            </Box>
          </Box>
        )}
    </Box>
  );
};

const EyeCatcher = () => {
  const theme = useTheme();
  const [popularCategories, setPopularCategories] = useState([]);
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchPopularCategories = async () => {
      try {
        const response = await instance.get('/api/products/popular-categories/search?limit=4');
        if (response.data && response.data.length > 0) {
          setPopularCategories(response.data.map(cat => cat.category).concat('Todos'));
        }
      } catch (error) {
        console.error('[NavBar] Error fetching popular categories:', error);
      }
    };

    fetchPopularCategories();
  }, []);

  return (
    <Box sx={{
      height: 'auto',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.background.default,
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
    }}>
           
      <Box sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row'}, gap: 1, px: 1}}>
        {/* Separate Box for the Typography */}

        <Box sx={{ display: 'flex', flexDirection: 'row', overflowX: 'auto', gap: 1}}>
          {popularCategories.map((category, index) => (
            <Chip 
              key={index} 
              label={category} 
              onClick={() => navigate(`/s/?category=${category}`)}
              sx={{
                fontSize: '1rem',
                fontFamily: 'Roboto',
                fontWeight: 500,
                px: 1,
                height: '32px',
                backgroundColor: '#ffffff',
                color: '#444444',
                transition: 'all 0.2s ease-in-out',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                  transition: 'all 0.5s ease',
                },
                '&:hover': {
                  backgroundColor: '#FF6F20',
                  color: '#fff',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 8px rgba(255,111,32,0.2)',
                  '&::before': {
                    left: '100%',
                  },
                },
                '&:active': {
                  transform: 'translateY(0)',
                  boxShadow: '0 2px 4px rgba(255,111,32,0.2)',
                },
              }}
            />
          ))}
        </Box>
        <Divider sx={{ backgroundColor: 'rgba(0,0,0,0.1)', mb: 1, height: 1 }}/>
      </Box>
    </Box>
  );
};



const ProductCard = ({ product }) =>
{
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <Card
        onClick={() => navigate(`/product/${product._id}`)}
        to={`/product/${product._id}`}
        href={`/product/${product._id}`}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          minHeight: '140px',
          cursor: 'pointer',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: {xs: '2px', sm: '12px'},
          borderBottom: { xs: '1px solid rgba(0,0,0,0.1)', sm: 'none' },
          boxShadow: {xs: 0, sm:'0 2px 8px rgba(0,0,0,0.08)'},
          mb: 0,
          p: 1,
        }}
      >
        {/* Image Section */}
        <Box sx={{
          width: '140px',
          my: {xs:0},
          borderRadius: '2px',
          minHeight: '140px',
          position: 'relative',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',

        }}>
        <CardMedia
          component="img"
          image={getCachedImage(product.imageUrls?.[0]?.replace('upload/', 'upload/q_auto/')) || LdPlaceHolder}
          alt={product.name}
          sx={{
            height: '100%',
            objectFit: 'contain',
            borderRadius: '2px'
          }}
        />
        
        </Box>

        {/* Content Section */}
        <CardContent sx={{
          flex: 1,
          '&:last-child': { pb: 1 }, // Override MUI's default padding
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          px:1
        }}>
          <Box>
            <Typography variant="h4" sx={{
              fontSize: '0.95rem',
              lineHeight: 1.2,
              mb: 0.5,
            }}>
              {product.name}
            </Typography>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
            <Typography variant="caption" color="text.secondary">
              {product.distributorName}
            </Typography>
            {product.distributorVerified && (
            <Tooltip title="Este distribuidor ha sido verificado por Liderdist." arrow placement="top">
              <Box sx={{

                zIndex: 2,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '50%',
                padding: '2px',
                width: {xs: '14px', md:'auto'},
                height: {xs: '14px', md:'auto'},
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <VerifiedIcon sx={{ fontSize: '12px' ,color: '#2196F3' }} />
              </Box>
            </Tooltip>
          )}
          </Box>
          </Box>

          <Box sx={{ my: 0.5 }}>
            <PriceDisplay
              basePrice={product.basePrice}
              priceBreaks={product.priceBreaks}
              hidePrice={product.hidePrice}
              unit={product.unit}
              isMobile={true}
            />
          </Box>

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt:2
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}>
              <LocationOnIcon sx={{ fontSize: '0.9rem', color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary" noWrap>
                {product.shippingZones?.[0] || 'Ubicación no especificada'}
              </Typography>
            </Box>
            
          </Box>
        </CardContent>
      </Card>
    );
  }

  // Return the original desktop version unchanged
  return (
    <Card
      onClick={() => navigate(`/product/${product._id}`)}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 12px 20px rgba(0,0,0,0.12)',
          '& .product-image': {
            transform: 'scale(1.05)'
          }
        }
      }}
    >
      {product.distributorVerified && (
        <Tooltip
          title="Este distribuidor ha sido verificado por Liderdist."
          arrow
          placement="top"
        >
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '50%',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <VerifiedIcon
              sx={{
                fontSize: '20px',
                filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))',
                 color: '#2196F3'
              }}
            />
          </Box>
        </Tooltip>
      )}

      <Box sx={{
        position: 'relative',
        pt: '75%',
        overflow: 'hidden'
      }}>
        <CardMedia
          component="img"
          image={getCachedImage(product.imageUrls?.[0]?.replace('upload/', 'upload/q_auto/')) || LdPlaceHolder}
          alt={product.name}
          className="product-image"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            transition: 'transform 0.3s ease'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '80%',
            background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
            p: 2,
            color: 'white',
            display: 'flex',
            justifyContent: 'end',
            flexDirection: 'column',
          }}
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            justifyContent: 'space-between'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5
            }}>
              <Typography variant="subtitle2" sx={{ opacity: 0.9 }}>
                {product.distributor?.name}
              </Typography>
              {product.distributorVerified && (
                <VerifiedIcon
                  sx={{
                    fontSize: '16px',
                    color: '#2196f3',
                    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))'
                  }}
                />
              )}
            </Box>
            <Typography
              variant="caption"
              sx={{
                opacity: 1,
                backgroundColor: 'rgba(255, 88, 51, 0.8)',
                px: 1.5,
                py: 0.5,
                borderRadius: 1,
                display: 'inline-block',
                maxWidth: '100%',
                textAlign: 'right',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textShadow: '0 1px 3px rgba(0,0,0,0.4)',
                fontWeight: 500,
                letterSpacing: '0.3px',
                fontSize: '0.75rem'
              }}
            >
              {product.category}
            </Typography>
          </Box>
        </Box>
      </Box>

      <CardContent sx={{
        flexGrow: 1,
        p: 1.5,
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Price and category */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexDirection: 'column',
          mb: 1.5
        }}>
           <Typography variant="h6" sx={{
            fontWeight: 500,
            fontSize: '0.9rem',
            mb: 0.5
          }}>
            {product.name}
          </Typography>
          <PriceDisplay
            basePrice={product.basePrice}
            priceBreaks={product.priceBreaks}
            hidePrice={product.hidePrice}
            unit={product.unit}
          />

        </Box>

        {/* Description */}
        {/* <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: (product.hasPriceBreaks) ? 4 : 8,
            WebkitBoxOrient: 'vertical',
            mb: 2,
            minHeight: '60px'
          }}
        >
          {product.description}
        </Typography> */}

        {/* Spacer to push location and stock to bottom */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Location and stock at bottom */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <LocationOnIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
            <Tooltip
              title={
                product.shippingZones?.length > 1
                  ? <Box sx={{ p: 1 }}>
                    {product.shippingZones.join(', ')}
                  </Box>
                  : ''
              }
              arrow
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  cursor: product.shippingZones?.length > 1 ? 'pointer' : 'default',
                  '&:hover': {
                    textDecoration: product.shippingZones?.length > 1 ? 'underline' : 'none'
                  },
                  lineHeight: 1.2,
                  display: 'block',
                  margin: 0
                }}
              >
                {product.shippingZones?.length > 0
                  ? `${product.shippingZones[0]}${product.shippingZones.length > 1 ? ` +${product.shippingZones.length - 1} más` : ''}`
                  : 'Ubicación no especificada'
                }
              </Typography>
            </Tooltip>
          </Box>
          {product.availableAmount > 0 && (
            <Chip
              size="small"
              label={`Disponible`}
              sx={{
                backgroundColor: 'rgba(76, 175, 80, 0.08)',
                color: 'success.main',
                fontSize: '0.75rem'
              }}
            />
          )}
          {product.availableAmount === 0 && (
            <Chip
              size="small"
              label={`Agotado`}
              sx={{
                backgroundColor: 'rgba(255, 88, 51, 0.08)',
                color: 'error.main',
                fontSize: '0.75rem'
              }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

const predefinedZones = [
  // Gran Buenos Aires
  'GBA Norte',
  'GBA Sur',
  'GBA Oeste',
  'CABA',

  // Provinces
  'Provincia de Buenos Aires',
  'Provincia de Córdoba',
  'Provincia de Santa Fe',
  'Provincia de Mendoza',
  'Provincia de Tucumán',
  'Provincia de Entre Ríos',
  'Provincia de Salta',
  'Provincia de Misiones',
  'Provincia de Chaco',
  'Provincia de Corrientes',
  'Provincia de Santiago del Estero',
  'Provincia de San Juan',
  'Provincia de Jujuy',
  'Provincia de Río Negro',
  'Provincia de Neuquén',
  'Provincia de Formosa',
  'Provincia de Chubut',
  'Provincia de San Luis',
  'Provincia de Catamarca',
  'Provincia de La Rioja',
  'Provincia de La Pampa',
  'Provincia de Santa Cruz',
  'Provincia de Tierra del Fuego',

  // Important Regions
  'Costa Atlántica',
  'Cuyo',
  'NOA',
  'NEA',
  'Patagonia Norte',
  'Patagonia Sur'
];

const hasActiveFilters = (params) =>
{
  return Array.from(params.keys()).length > 0;
};

// Add this helper function to find the category path
const getCategoryPath = (category) =>
{
  if (!category) return [];

  // Check if it's a main category
  if (CATEGORY_HIERARCHY[category])
  {
    return [category];
  }

  // Look for the category in subcategories
  for (const [mainCat, data] of Object.entries(CATEGORY_HIERARCHY))
  {
    for (const [subCat, items] of Object.entries(data.subcategories))
    {
      if (subCat === category || items.includes(category))
      {
        if (items.includes(category))
        {
          return [mainCat, subCat, category];
        }
        return [mainCat, subCat];
      }
    }
  }

  return [category]; // Return single category if not found in hierarchy
};

const LandingPage = () =>
{
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [totalAccumulated, setTotalAccumulated] = useState(0);
  const [filters, setFilters] = useState({
    priceRange: '',
    category: '',
    location: '',
    availability: false,
    sortBy: 'createdAt',
    sortOrder: 'desc'
  });

  const [openDialog, setOpenDialog] = useState(null);
  const [page, setPage] = useState(1);
  const [paginationData, setPaginationData] = useState({
    currentPage: 1,
    totalPages: 1,
    totalProducts: 0,
  });
  const [searchInput, setSearchInput] = useState(filters.searchTerm);
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [showAllcategory, setShowAllcategory] = useState(false);

  const [selectedProvince, setSelectedProvince] = useState(null);
  const [availableCities, setAvailableCities] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);

  // State for the filter menu inputs (doesn't affect filtering until applied)
  const [filterInputs, setFilterInputs] = useState({
    search: searchParams.get('search') || '',
    category: searchParams.get('category') || '',
    location: searchParams.get('location') || '',
    priceRange: {
      min: searchParams.get('minPrice') || '',
      max: searchParams.get('maxPrice') || ''
    },
    stockRange: {
      min: searchParams.get('minStock') || '',
      max: searchParams.get('maxStock') || ''
    },
    showWithStock: searchParams.get('inStock') === 'true',
    showWithPrice: searchParams.get('hidePrice') === 'false',
    verifiedDistributors: searchParams.get('verifiedDistributor') === 'true',
    province: searchParams.get('province') || '',
    city: searchParams.get('city') || '',
  });

  const [selectedMainCategory, setSelectedMainCategory] = useState(searchParams.get('category'));
  const [selectedSubCategory, setSelectedSubCategory] = useState(searchParams.get('category'));

  const resetFilters = () =>
  {
    setFilterInputs({
      category: '',
      location: '',
      priceRange: { min: '', max: '' },
      stockRange: { min: '', max: '' },
      showWithStock: false,
      showWithPrice: false,
      verifiedDistributors: false,
      province: '',
      city: '',
    });
    setSearchParams(new URLSearchParams());
  };

  const handlePageChange = (event, newPage) =>
  {
    setPage(newPage);
    setSearchParams(new URLSearchParams({ ...Object.fromEntries(searchParams.entries()), page: newPage }));
  };

  // Fetch products based on URL params
  useEffect(() =>
  {
    const fetchProducts = async () =>
    {
      try
      {
        setProductsLoading(true);
        const response = await instance.get(`/api/products?${searchParams.toString()}`);

        setProducts(response.data.products);
        setFeaturedProducts(response.data.products.filter(product => product.isFeatured));
        setPaginationData({
          currentPage: response.data.currentPage,
          totalPages: response.data.totalPages,
          totalProducts: response.data.totalProducts
        });

        // Update category path when URL changes
        const categoryParam = searchParams.get('category');
        if (categoryParam)
        {
          const path = getCategoryPath(categoryParam);
          setSelectedMainCategory(path[0]);
          setSelectedSubCategory(path.length > 1 ? path[1] : null);
          setFilterInputs(prev => ({ ...prev, category: categoryParam }));
        } else
        {
          // Reset category selections when no category in URL
          setSelectedMainCategory(null);
          setSelectedSubCategory(null);
          setFilterInputs(prev => ({ ...prev, category: '' }));
        }

      } catch (error)
      {
        console.error('Error fetching products:', error);
        setProducts([]);
      } finally
      {
        setProductsLoading(false);
      }
    };

    fetchProducts();
  }, [searchParams]); // Depend on searchParams changes

  // When "Buscar" is clicked, update URL with filter menu values
  const handleApplyFilters = () =>
  {
    const newParams = new URLSearchParams(searchParams);

    // Update params with filter menu values
    if (filterInputs.category)
    {
      newParams.set('category', filterInputs.category);
    } else
    {
      newParams.delete('category');
    }

    // Special handling for location to include "Todo el país"
    if (filterInputs.location)
    {
      // Send both the selected location and "Todo el país"
      newParams.set('location', JSON.stringify([filterInputs.location, 'Todo el país']));
    } else
    {
      newParams.delete('location');
    }

    if (filterInputs.priceRange.min)
    {
      newParams.set('minPrice', filterInputs.priceRange.min);
    } else
    {
      newParams.delete('minPrice');
    }

    if (filterInputs.priceRange.max)
    {
      newParams.set('maxPrice', filterInputs.priceRange.max);
    } else
    {
      newParams.delete('maxPrice');
    }

    if (filterInputs.stockRange.min)
    {
      newParams.set('minStock', filterInputs.stockRange.min);
    } else
    {
      newParams.delete('minStock');
    }

    if (filterInputs.stockRange.max)
    {
      newParams.set('maxStock', filterInputs.stockRange.max);
    } else
    {
      newParams.delete('maxStock');
    }

    if (filterInputs.showWithStock)
    {
      newParams.set('inStock', 'true');
    } else
    {
      newParams.delete('inStock');
    }
    if (filterInputs.showWithPrice)
    {
      newParams.set('hidePrice', 'false');
    } else
    {
      newParams.delete('hidePrice');
    }
    if (filterInputs.verifiedDistributors)
    {
      newParams.set('verifiedDistributor', 'true');
    } else
    {
      newParams.delete('verifiedDistributor');
    }

    if (filterInputs.province) {
      newParams.set('province', filterInputs.province);
    } else {
      newParams.delete('province');
    }

    if (filterInputs.city) {
      newParams.set('city', filterInputs.city);
    } else {
      newParams.delete('city');
    }

    // Update URL with new params
    setSearchParams(newParams);
  };

  // Add this helper function to get subcategories
  const getSubcategories = (category) =>
  {
    if (!category) return [];
    if (CATEGORY_HIERARCHY[category])
    {
      return Object.keys(CATEGORY_HIERARCHY[category].subcategories);
    }
    return [];
  };

  // Add this helper function to get leaf categories
  const getLeafCategories = (mainCategory, subCategory) =>
  {
    if (!mainCategory || !subCategory) return [];
    return CATEGORY_HIERARCHY[mainCategory]?.subcategories[subCategory] || [];
  };

  // Add state for filter menu collapse
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  // Define styled components for the filter and sort bars
  const FilterBar = styled(Box)(({ theme }) => ({
    width: '100vw',
    position: 'relative',
    height: '40px',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    zIndex: 1,
  }));

  const SortBar = styled(Box)(({ theme }) => ({
    width: '100vw',
    height: '40px',
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    backgroundColor: "#fc8403",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    zIndex: 1,
  }));

  const category = searchParams.get('category');
  
  // Create SEO-friendly titles and descriptions based on category
  const getSEOData = (category) => {
    if (!category) {
      return {
        title: 'Liderdist | Mayoristas y Distribuidores en Argentina',
        description: 'Encontrá los mejores productos mayoristas en Argentina. Conectamos distribuidores verificados con comercios.'
      };
    }

    // Find the main category and subcategory
    let mainCategory = null;
    let isSubcategory = false;
    let parentCategory = null;

    // Search through the hierarchy
    for (const [main, data] of Object.entries(CATEGORY_HIERARCHY)) {
      if (main === category) {
        mainCategory = data;
        break;
      }
      
      // Check subcategories
      for (const [sub, items] of Object.entries(data.subcategories)) {
        if (sub === category) {
          mainCategory = data;
          isSubcategory = true;
          parentCategory = main;
          break;
        }
        // Check items within subcategories
        if (items.includes(category)) {
          mainCategory = data;
          isSubcategory = true;
          parentCategory = main;
          break;
        }
      }
    }

    // Create category-specific SEO content
    const categoryMappings = {
      // Main Categories
      "Alimentos": {
        title: 'Alimentos y Bebidas Mayorista | Distribuidores de Alimentos | Liderdist',
        description: 'Encuentra distribuidores mayoristas de alimentos y bebidas en Argentina. Conectamos comercios con proveedores verificados de productos alimenticios.'
      },
      "Electrónica": {
        title: 'Electrónica y Tecnología Mayorista | Distribuidores de Electrónica | Liderdist',
        description: 'Distribuidores mayoristas de electrónica y tecnología. Encuentra proveedores verificados de productos electrónicos en Argentina.'
      },
      
      // Alimentos Subcategories
      "Carnes Rojas": {
        title: 'Carnes Rojas Mayorista | Distribuidores de Carne | Liderdist',
        description: 'Distribuidores mayoristas de carnes rojas en Argentina. Carne vacuna, cordero y más. Proveedores verificados con precios directos.'
      },
      "Carne Vacuna": {
        title: 'Carne Vacuna Mayorista | Distribuidores de Carne | Liderdist',
        description: 'Encuentra distribuidores mayoristas de carne vacuna en Argentina. Cortes frescos y de calidad a precios mayoristas.'
      },
      "Carnes de Cerdo": {
        title: 'Cerdo Mayorista | Distribuidores de Carne de Cerdo | Liderdist',
        description: 'Distribuidores mayoristas de carne de cerdo. Cortes frescos, embutidos y fiambres a precios directos de fábrica.'
      },
      "Pescados y Mariscos": {
        title: 'Pescados y Mariscos Mayorista | Distribuidores | Liderdist',
        description: 'Conectamos con distribuidores mayoristas de pescados y mariscos. Productos frescos y congelados de calidad.'
      },
      "Lácteos y Huevos": {
        title: 'Lácteos y Huevos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de lácteos y huevos. Leche, quesos, yogurt y más a precios mayoristas.'
      },
      "Bebidas Alcohólicas": {
        title: 'Bebidas Alcohólicas Mayorista | Vinos y Licores | Liderdist',
        description: 'Distribuidores mayoristas de bebidas alcohólicas. Vinos, cervezas, licores y más. Precios directos de bodega.'
      },
      "Vinos": {
        title: 'Vinos Mayorista | Distribuidores de Vinos | Liderdist',
        description: 'Conectamos con bodegas y distribuidores mayoristas de vinos. Precios directos sin intermediarios.'
      },
      
      // Electrónica Subcategories
      "Televisores": {
        title: 'Televisores Mayorista | Smart TV y LED | Liderdist',
        description: 'Distribuidores mayoristas de televisores. Smart TV, LED, OLED y más. Marcas líderes a precios mayoristas.'
      },
      "Smart TV": {
        title: 'Smart TV Mayorista | Distribuidores de Televisores | Liderdist',
        description: 'Encuentra distribuidores mayoristas de Smart TV. Las mejores marcas con precios directos de fábrica.'
      },
      "Celulares y Tablets": {
        title: 'Celulares y Tablets Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de celulares y tablets. Smartphones y tablets de las mejores marcas.'
      },
      
      // Industria Categories
      "Maquinaria Industrial": {
        title: 'Maquinaria Industrial Mayorista | Equipamiento Industrial | Liderdist',
        description: 'Distribuidores mayoristas de maquinaria y equipamiento industrial. Soluciones para la industria.'
      },
      "Máquinas CNC": {
        title: 'Máquinas CNC Mayorista | Equipamiento Industrial | Liderdist',
        description: 'Distribuidores mayoristas de máquinas CNC. Equipamiento de precisión industrial.'
      },
      
      // Químicos Categories
      "Químicos Industriales": {
        title: 'Químicos Industriales Mayorista | Productos Químicos | Liderdist',
        description: 'Distribuidores mayoristas de productos químicos industriales. Insumos químicos de calidad certificada.'
      },
      "Ácidos": {
        title: 'Ácidos Industriales Mayorista | Químicos | Liderdist',
        description: 'Distribuidores mayoristas de ácidos industriales. Productos químicos con certificación de calidad.'
      },
      
      // Agricultura Categories
      "Insumos Agrícolas": {
        title: 'Insumos Agrícolas Mayorista | Agricultura | Liderdist',
        description: 'Distribuidores mayoristas de insumos agrícolas. Fertilizantes, semillas y agroquímicos.'
      },
      "Fertilizantes": {
        title: 'Fertilizantes Mayorista | Insumos Agrícolas | Liderdist',
        description: 'Distribuidores mayoristas de fertilizantes. Productos para el campo a precios directos.'
      },
      
      // Embalajes Categories
      "Cajas y Contenedores": {
        title: 'Cajas y Contenedores Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de cajas y contenedores. Soluciones de embalaje industrial.'
      },
      "Film Stretch": {
        title: 'Film Stretch Mayorista | Material de Embalaje | Liderdist',
        description: 'Distribuidores mayoristas de film stretch. Materiales de embalaje a precios directos de fábrica.'
      },
      // More Alimentos Subcategories
      "Aves": {
        title: 'Aves Mayorista | Distribuidores de Pollo y Aves | Liderdist',
        description: 'Distribuidores mayoristas de pollo y otras aves. Productos frescos y congelados a precios mayoristas.'
      },
      "Pollo": {
        title: 'Pollo Mayorista | Distribuidores de Pollo | Liderdist',
        description: 'Encuentra distribuidores mayoristas de pollo. Productos frescos y congelados con precios directos.'
      },
      "Frutas y Verduras": {
        title: 'Frutas y Verduras Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de frutas y verduras. Productos frescos de calidad para comercios.'
      },
      "Panadería": {
        title: 'Panadería Mayorista | Distribuidores de Panificados | Liderdist',
        description: 'Conectamos con distribuidores mayoristas de productos de panadería. Pan fresco, facturas y más.'
      },
      "Bebidas Sin Alcohol": {
        title: 'Bebidas Sin Alcohol Mayorista | Gaseosas y Aguas | Liderdist',
        description: 'Distribuidores mayoristas de bebidas sin alcohol. Gaseosas, aguas, jugos y más a precios mayoristas.'
      },
      "Infusiones": {
        title: 'Infusiones Mayorista | Yerba Mate y Café | Liderdist',
        description: 'Distribuidores mayoristas de yerba mate, té, café y otras infusiones. Precios directos de fábrica.'
      },
      "Alimentos Secos": {
        title: 'Alimentos Secos Mayorista | Arroz, Pasta y Legumbres | Liderdist',
        description: 'Distribuidores mayoristas de alimentos secos. Arroz, pasta, legumbres y más a precios mayoristas.'
      },
      "Congelados": {
        title: 'Alimentos Congelados Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de alimentos congelados. Comidas preparadas, vegetales y más.'
      },
      "Conservas": {
        title: 'Conservas Mayorista | Enlatados y Conservas | Liderdist',
        description: 'Distribuidores mayoristas de conservas y enlatados. Productos de larga duración a precios mayoristas.'
      },
      "Aceites y Vinagres": {
        title: 'Aceites y Vinagres Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de aceites y vinagres. Aceite de oliva, vinagres y más a precios directos.'
      },
      "Condimentos y Especias": {
        title: 'Condimentos y Especias Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de condimentos y especias. Productos de calidad para tu negocio.'
      },
      "Salsas y Aderezos": {
        title: 'Salsas y Aderezos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de salsas y aderezos. Mayonesa, mostaza, ketchup y más.'
      },
      "Snacks y Golosinas": {
        title: 'Snacks y Golosinas Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de snacks y golosinas. Papas fritas, chocolates y más.'
      },

      // More Electrónica Subcategories
      "Computadoras": {
        title: 'Computadoras Mayorista | PCs y Notebooks | Liderdist',
        description: 'Distribuidores mayoristas de computadoras. PCs, notebooks y componentes a precios mayoristas.'
      },
      "Electrodomésticos": {
        title: 'Electrodomésticos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de electrodomésticos. Las mejores marcas a precios directos.'
      },
      "Audio y Video": {
        title: 'Audio y Video Mayorista | Equipos de Sonido | Liderdist',
        description: 'Distribuidores mayoristas de equipos de audio y video. Sistemas de sonido profesional.'
      },
      "Monitores": {
        title: 'Monitores Mayorista | Pantallas LED y LCD | Liderdist',
        description: 'Distribuidores mayoristas de monitores. Pantallas LED, LCD y más a precios competitivos.'
      },

      // More Industria Categories
      "Herramientas Eléctricas": {
        title: 'Herramientas Eléctricas Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de herramientas eléctricas. Equipamiento profesional para industria.'
      },
      "Compresores Industriales": {
        title: 'Compresores Industriales Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de compresores industriales. Equipos de alta calidad y rendimiento.'
      },
      "Equipamiento de Seguridad": {
        title: 'Equipamiento de Seguridad Industrial Mayorista | Liderdist',
        description: 'Distribuidores mayoristas de equipos de seguridad industrial. EPP y protección laboral.'
      },

      // More Químicos Categories
      "Solventes Químicos": {
        title: 'Solventes Químicos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de solventes químicos. Productos certificados para industria.'
      },
      "Productos de Limpieza": {
        title: 'Productos de Limpieza Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de productos de limpieza. Insumos profesionales e industriales.'
      },

      // More Agricultura Categories
      "Semillas": {
        title: 'Semillas Mayorista | Distribuidores Agrícolas | Liderdist',
        description: 'Distribuidores mayoristas de semillas. Variedades certificadas para cultivos.'
      },
      "Agroquímicos": {
        title: 'Agroquímicos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de agroquímicos. Productos fitosanitarios certificados.'
      },
      "Maquinaria Agrícola": {
        title: 'Maquinaria Agrícola Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de maquinaria agrícola. Equipamiento para el campo.'
      },

      // Detailed Alimentos Subcategories
      "Carne de Cordero": {
        title: 'Carne de Cordero Mayorista | Distribuidores de Carne | Liderdist',
        description: 'Distribuidores mayoristas de carne de cordero. Cortes frescos y de calidad a precios directos.'
      },
      "Achuras": {
        title: 'Achuras Mayorista | Distribuidores de Achuras | Liderdist',
        description: 'Distribuidores mayoristas de achuras. Productos frescos para carnicerías y comercios.'
      },
      "Hamburguesas": {
        title: 'Hamburguesas Mayorista | Distribuidores de Carne | Liderdist',
        description: 'Distribuidores mayoristas de hamburguesas. Productos frescos y congelados para comercios.'
      },
      "Cortes Frescos": {
        title: 'Cortes Frescos de Cerdo Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de cortes frescos de cerdo. Calidad garantizada a precios mayoristas.'
      },
      "Embutidos": {
        title: 'Embutidos Mayorista | Distribuidores de Fiambres | Liderdist',
        description: 'Distribuidores mayoristas de embutidos. Chorizo, morcilla y más a precios directos.'
      },
      "Fiambres": {
        title: 'Fiambres Mayorista | Distribuidores de Fiambres | Liderdist',
        description: 'Distribuidores mayoristas de fiambres. Jamón, salame y más para comercios.'
      },
      "Panceta": {
        title: 'Panceta Mayorista | Distribuidores de Cerdo | Liderdist',
        description: 'Distribuidores mayoristas de panceta. Productos de cerdo de primera calidad.'
      },
      "Pescados Frescos": {
        title: 'Pescados Frescos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de pescados frescos. Variedad de especies a precios mayoristas.'
      },
      "Pescados Congelados": {
        title: 'Pescados Congelados Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de pescados congelados. Calidad garantizada para comercios.'
      },
      "Mariscos": {
        title: 'Mariscos Mayorista | Distribuidores de Mariscos | Liderdist',
        description: 'Distribuidores mayoristas de mariscos. Productos frescos y congelados de primera calidad.'
      },
      "Conservas de Pescado": {
        title: 'Conservas de Pescado Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de conservas de pescado. Atún, sardinas y más.'
      },
      "Pavo": {
        title: 'Pavo Mayorista | Distribuidores de Aves | Liderdist',
        description: 'Distribuidores mayoristas de pavo. Productos frescos y congelados para comercios.'
      },
      "Pato": {
        title: 'Pato Mayorista | Distribuidores de Aves | Liderdist',
        description: 'Distribuidores mayoristas de pato. Aves de calidad para restaurantes y comercios.'
      },
      "Menudencias": {
        title: 'Menudencias Mayorista | Distribuidores de Aves | Liderdist',
        description: 'Distribuidores mayoristas de menudencias de aves. Productos frescos a precios mayoristas.'
      },
      "Leche": {
        title: 'Leche Mayorista | Distribuidores de Lácteos | Liderdist',
        description: 'Distribuidores mayoristas de leche. Productos lácteos frescos para comercios.'
      },
      "Quesos": {
        title: 'Quesos Mayorista | Distribuidores de Lácteos | Liderdist',
        description: 'Distribuidores mayoristas de quesos. Amplia variedad de quesos nacionales e importados.'
      },
      "Yogurt": {
        title: 'Yogurt Mayorista | Distribuidores de Lácteos | Liderdist',
        description: 'Distribuidores mayoristas de yogurt. Productos lácteos frescos a precios directos.'
      },
      "Manteca": {
        title: 'Manteca Mayorista | Distribuidores de Lácteos | Liderdist',
        description: 'Distribuidores mayoristas de manteca. Productos lácteos de calidad para comercios.'
      },
      "Crema": {
        title: 'Crema Mayorista | Distribuidores de Lácteos | Liderdist',
        description: 'Distribuidores mayoristas de crema. Productos lácteos frescos para tu negocio.'
      },
      "Huevos": {
        title: 'Huevos Mayorista | Distribuidores de Huevos | Liderdist',
        description: 'Distribuidores mayoristas de huevos. Productos frescos con entrega directa.'
      },
      "Frutas Frescas": {
        title: 'Frutas Frescas Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de frutas frescas. Productos de estación a precios mayoristas.'
      },
      "Verduras Frescas": {
        title: 'Verduras Frescas Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de verduras frescas. Productos de huerta a precios directos.'
      },
      "Frutas Secas": {
        title: 'Frutas Secas Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de frutas secas. Nueces, almendras y más para comercios.'
      },
      "Verduras Congeladas": {
        title: 'Verduras Congeladas Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de verduras congeladas. Productos de calidad para comercios.'
      },

      // Detailed Bebidas Alcohólicas Categories
      "Cervezas": {
        title: 'Cervezas Mayorista | Distribuidores de Cerveza | Liderdist',
        description: 'Distribuidores mayoristas de cervezas. Marcas nacionales e importadas a precios directos.'
      },
      "Espumantes": {
        title: 'Espumantes Mayorista | Champagne y Espumantes | Liderdist',
        description: 'Distribuidores mayoristas de espumantes y champagne. Productos de calidad para eventos y comercios.'
      },
      "Licores": {
        title: 'Licores Mayorista | Distribuidores de Licores | Liderdist',
        description: 'Distribuidores mayoristas de licores. Amplia variedad de licores nacionales e importados.'
      },
      "Whisky": {
        title: 'Whisky Mayorista | Distribuidores de Whisky | Liderdist',
        description: 'Distribuidores mayoristas de whisky. Marcas premium y estándar a precios competitivos.'
      },
      "Vodka": {
        title: 'Vodka Mayorista | Distribuidores de Vodka | Liderdist',
        description: 'Distribuidores mayoristas de vodka. Marcas nacionales e importadas para comercios.'
      },
      "Gin": {
        title: 'Gin Mayorista | Distribuidores de Gin | Liderdist',
        description: 'Distribuidores mayoristas de gin. Productos premium y artesanales a precios mayoristas.'
      },
      "Ron": {
        title: 'Ron Mayorista | Distribuidores de Ron | Liderdist',
        description: 'Distribuidores mayoristas de ron. Variedades premium y estándar para comercios.'
      },
      "Fernet": {
        title: 'Fernet Mayorista | Distribuidores de Fernet | Liderdist',
        description: 'Distribuidores mayoristas de fernet. Marcas líderes a precios competitivos.'
      },

      // Detailed Electronics Categories
      "Smartphones": {
        title: 'Smartphones Mayorista | Celulares | Liderdist',
        description: 'Distribuidores mayoristas de smartphones. Las mejores marcas a precios competitivos.'
      },
      "Tablets": {
        title: 'Tablets Mayorista | Distribuidores de Tablets | Liderdist',
        description: 'Distribuidores mayoristas de tablets. Productos de última generación a precios mayoristas.'
      },
      "Notebooks": {
        title: 'Notebooks Mayorista | Laptops | Liderdist',
        description: 'Distribuidores mayoristas de notebooks. Equipos portátiles de las mejores marcas.'
      },
      "PCs de Escritorio": {
        title: 'PCs de Escritorio Mayorista | Computadoras | Liderdist',
        description: 'Distribuidores mayoristas de computadoras de escritorio. Equipos completos y componentes.'
      },
      "Componentes PC": {
        title: 'Componentes PC Mayorista | Hardware | Liderdist',
        description: 'Distribuidores mayoristas de componentes para PC. Procesadores, placas madre y más.'
      },
      "Impresoras": {
        title: 'Impresoras Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de impresoras. Equipos láser e inkjet para oficina y hogar.'
      },
      "Accesorios Computación": {
        title: 'Accesorios Computación Mayorista | Periféricos | Liderdist',
        description: 'Distribuidores mayoristas de accesorios para computación. Teclados, mouse y más.'
      },

      // Detailed Industrial Categories
      "Tornos": {
        title: 'Tornos Mayorista | Máquinas Herramienta | Liderdist',
        description: 'Distribuidores mayoristas de tornos industriales. Equipamiento de precisión para metalurgia.'
      },
      "Fresadoras": {
        title: 'Fresadoras Mayorista | Máquinas Herramienta | Liderdist',
        description: 'Distribuidores mayoristas de fresadoras. Equipos de precisión para la industria metalúrgica.'
      },
      "Soldadoras": {
        title: 'Soldadoras Mayorista | Equipos de Soldadura | Liderdist',
        description: 'Distribuidores mayoristas de equipos de soldadura. Máquinas y consumibles para industria.'
      },
      "Herramientas Manuales": {
        title: 'Herramientas Manuales Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de herramientas manuales. Equipamiento profesional para industria.'
      },
      "Equipos de Medición": {
        title: 'Equipos de Medición Mayorista | Instrumentos | Liderdist',
        description: 'Distribuidores mayoristas de equipos de medición industrial. Instrumentos de precisión.'
      },
      "Bombas Industriales": {
        title: 'Bombas Industriales Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de bombas industriales. Equipos para fluidos y procesos.'
      },
      "Motores Eléctricos": {
        title: 'Motores Eléctricos Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de motores eléctricos. Equipos para aplicaciones industriales.'
      },

      // Chemical Products
      "Productos Químicos Básicos": {
        title: 'Productos Químicos Básicos Mayorista | Químicos | Liderdist',
        description: 'Distribuidores mayoristas de productos químicos básicos. Insumos industriales certificados.'
      },
      "Reactivos": {
        title: 'Reactivos Químicos Mayorista | Laboratorio | Liderdist',
        description: 'Distribuidores mayoristas de reactivos químicos. Productos para laboratorio e investigación.'
      },
      "Material de Laboratorio": {
        title: 'Material de Laboratorio Mayorista | Equipamiento | Liderdist',
        description: 'Distribuidores mayoristas de material de laboratorio. Equipos y consumibles.'
      },
      "Productos de Limpieza Industrial": {
        title: 'Limpieza Industrial Mayorista | Químicos | Liderdist',
        description: 'Distribuidores mayoristas de productos de limpieza industrial. Soluciones profesionales.'
      },

      // Agricultural Products
      "Sistemas de Riego": {
        title: 'Sistemas de Riego Mayorista | Agricultura | Liderdist',
        description: 'Distribuidores mayoristas de sistemas de riego. Equipamiento para agricultura.'
      },
      "Invernaderos": {
        title: 'Invernaderos Mayorista | Agricultura | Liderdist',
        description: 'Distribuidores mayoristas de invernaderos. Estructuras y equipamiento.'
      },
      "Alimento Balanceado": {
        title: 'Alimento Balanceado Mayorista | Ganadería | Liderdist',
        description: 'Distribuidores mayoristas de alimento balanceado. Nutrición animal.'
      },
      "Sanidad Animal": {
        title: 'Sanidad Animal Mayorista | Veterinaria | Liderdist',
        description: 'Distribuidores mayoristas de productos veterinarios. Medicamentos y suplementos.'
      },

      // Packaging Materials
      "Cajas de Cartón": {
        title: 'Cajas de Cartón Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de cajas de cartón. Soluciones de packaging.'
      },
      "Bolsas": {
        title: 'Bolsas Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de bolsas. Material de empaque industrial.'
      },
      "Cintas Adhesivas": {
        title: 'Cintas Adhesivas Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de cintas adhesivas. Materiales de embalaje.'
      },
      "Pallets": {
        title: 'Pallets Mayorista | Logística | Liderdist',
        description: 'Distribuidores mayoristas de pallets. Equipamiento logístico industrial.'
      },

      // Construction Materials
      "Cemento": {
        title: 'Cemento Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de cemento. Materiales de construcción.'
      },
      "Hierros": {
        title: 'Hierros Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de hierros. Materiales para construcción.'
      },
      "Ladrillos": {
        title: 'Ladrillos Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de ladrillos. Materiales de construcción.'
      },
      "Pinturas": {
        title: 'Pinturas Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de pinturas. Recubrimientos y acabados.'
      },

      // Office Supplies
      "Papelería": {
        title: 'Papelería Mayorista | Insumos de Oficina | Liderdist',
        description: 'Distribuidores mayoristas de papelería. Artículos de oficina.'
      },
      "Artículos de Escritorio": {
        title: 'Artículos de Escritorio Mayorista | Oficina | Liderdist',
        description: 'Distribuidores mayoristas de artículos de escritorio. Insumos de oficina.'
      },
      "Mobiliario de Oficina": {
        title: 'Mobiliario de Oficina Mayorista | Muebles | Liderdist',
        description: 'Distribuidores mayoristas de mobiliario de oficina. Equipamiento profesional.'
      },

      // Automotive
      "Repuestos Automotor": {
        title: 'Repuestos Automotor Mayorista | Autopartes | Liderdist',
        description: 'Distribuidores mayoristas de repuestos automotor. Autopartes originales.'
      },
      "Lubricantes": {
        title: 'Lubricantes Mayorista | Automotor | Liderdist',
        description: 'Distribuidores mayoristas de lubricantes. Aceites y grasas industriales.'
      },
      "Neumáticos": {
        title: 'Neumáticos Mayorista | Automotor | Liderdist',
        description: 'Distribuidores mayoristas de neumáticos. Cubiertas para vehículos.'
      },

      // Safety Equipment
      "Elementos de Protección Personal": {
        title: 'EPP Mayorista | Seguridad Industrial | Liderdist',
        description: 'Distribuidores mayoristas de elementos de protección personal. Equipos de seguridad.'
      },
      "Indumentaria de Trabajo": {
        title: 'Indumentaria de Trabajo Mayorista | Seguridad | Liderdist',
        description: 'Distribuidores mayoristas de indumentaria de trabajo. Ropa de seguridad.'
      },
      "Señalización": {
        title: 'Señalización Mayorista | Seguridad Industrial | Liderdist',
        description: 'Distribuidores mayoristas de señalización industrial. Elementos de seguridad.'
      },

      // Textile
      "Telas": {
        title: 'Telas Mayorista | Textil | Liderdist',
        description: 'Distribuidores mayoristas de telas. Materiales textiles industriales.'
      },
      "Hilados": {
        title: 'Hilados Mayorista | Textil | Liderdist',
        description: 'Distribuidores mayoristas de hilados. Insumos para industria textil.'
      },
      "Accesorios Textiles": {
        title: 'Accesorios Textiles Mayorista | Mercería | Liderdist',
        description: 'Distribuidores mayoristas de accesorios textiles. Insumos de mercería.'
      },

      // Plastics
      "Materias Primas Plásticas": {
        title: 'Materias Primas Plásticas Mayorista | Plásticos | Liderdist',
        description: 'Distribuidores mayoristas de materias primas plásticas. Insumos industriales.'
      },
      "Productos Plásticos": {
        title: 'Productos Plásticos Mayorista | Plásticos | Liderdist',
        description: 'Distribuidores mayoristas de productos plásticos. Artículos industriales.'
      },

      // Medical Supplies
      "Insumos Médicos": {
        title: 'Insumos Médicos Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de insumos médicos. Equipamiento hospitalario.'
      },
      "Equipamiento Médico": {
        title: 'Equipamiento Médico Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de equipamiento médico. Tecnología médica.'
      },
      "Productos Descartables": {
        title: 'Productos Descartables Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de productos descartables médicos. Insumos hospitalarios.'
      },

      // Additional Food Categories
      "Pollo": {
        title: 'Pollo Mayorista | Distribuidores de Pollo | Liderdist',
        description: 'Distribuidores mayoristas de pollo. Productos frescos y congelados para comercios.'
      },
      "Vinos": {
        title: 'Vinos Mayorista | Distribuidores de Vinos | Liderdist',
        description: 'Distribuidores mayoristas de vinos. Amplia selección de vinos nacionales e importados.'
      },
      "Gaseosas": {
        title: 'Gaseosas Mayorista | Bebidas Sin Alcohol | Liderdist',
        description: 'Distribuidores mayoristas de gaseosas. Marcas líderes a precios competitivos.'
      },
      "Aguas": {
        title: 'Aguas Mayorista | Bebidas Sin Alcohol | Liderdist',
        description: 'Distribuidores mayoristas de aguas. Agua mineral y saborizada para comercios.'
      },
      "Jugos": {
        title: 'Jugos Mayorista | Bebidas Sin Alcohol | Liderdist',
        description: 'Distribuidores mayoristas de jugos. Bebidas naturales y concentrados.'
      },
      "Energizantes": {
        title: 'Energizantes Mayorista | Bebidas Sin Alcohol | Liderdist',
        description: 'Distribuidores mayoristas de bebidas energizantes. Marcas líderes del mercado.'
      },
      "Bebidas Deportivas": {
        title: 'Bebidas Deportivas Mayorista | Isotónicas | Liderdist',
        description: 'Distribuidores mayoristas de bebidas deportivas. Hidratación y rendimiento.'
      },
      "Yerba Mate": {
        title: 'Yerba Mate Mayorista | Distribuidores | Liderdist',
        description: 'Distribuidores mayoristas de yerba mate. Marcas tradicionales y premium.'
      },
      "Mates": {
        title: 'Mates Mayorista | Accesorios Mate | Liderdist',
        description: 'Distribuidores mayoristas de mates y accesorios. Productos tradicionales.'
      },
      "Café": {
        title: 'Café Mayorista | Distribuidores de Café | Liderdist',
        description: 'Distribuidores mayoristas de café. Granos, molido y solubles.'
      },
      "Arroz": {
        title: 'Arroz Mayorista | Alimentos Secos | Liderdist',
        description: 'Distribuidores mayoristas de arroz. Variedades nacionales e importadas.'
      },
      "Pasta": {
        title: 'Pasta Mayorista | Alimentos Secos | Liderdist',
        description: 'Distribuidores mayoristas de pasta. Fideos y pastas secas.'
      },
      "Legumbres": {
        title: 'Legumbres Mayorista | Alimentos Secos | Liderdist',
        description: 'Distribuidores mayoristas de legumbres. Productos secos y envasados.'
      },
      "Cereales": {
        title: 'Cereales Mayorista | Alimentos Secos | Liderdist',
        description: 'Distribuidores mayoristas de cereales. Desayuno y snacks.'
      },
      "Harinas": {
        title: 'Harinas Mayorista | Alimentos Secos | Liderdist',
        description: 'Distribuidores mayoristas de harinas. Productos para panadería y repostería.'
      },

      // Additional Electronics Categories
      "Smart TV": {
        title: 'Smart TV Mayorista | Televisores | Liderdist',
        description: 'Distribuidores mayoristas de Smart TV. Últimas tecnologías y marcas líderes.'
      },
      "LED TV": {
        title: 'LED TV Mayorista | Televisores | Liderdist',
        description: 'Distribuidores mayoristas de LED TV. Pantallas de alta definición.'
      },
      "OLED TV": {
        title: 'OLED TV Mayorista | Televisores | Liderdist',
        description: 'Distribuidores mayoristas de OLED TV. Tecnología de última generación.'
      },
      "Accesorios TV": {
        title: 'Accesorios TV Mayorista | Televisores | Liderdist',
        description: 'Distribuidores mayoristas de accesorios para TV. Soportes y cables.'
      },

      // Additional Home Categories
      "Sillones y Sofás": {
        title: 'Sillones y Sofás Mayorista | Muebles | Liderdist',
        description: 'Distribuidores mayoristas de sillones y sofás. Muebles de calidad.'
      },
      "Mesas y Sillas": {
        title: 'Mesas y Sillas Mayorista | Muebles | Liderdist',
        description: 'Distribuidores mayoristas de mesas y sillas. Mobiliario para hogar.'
      },
      "Camas y Colchones": {
        title: 'Camas y Colchones Mayorista | Muebles | Liderdist',
        description: 'Distribuidores mayoristas de camas y colchones. Descanso de calidad.'
      },

      // Additional Food Categories
      "Comidas Preparadas": {
        title: 'Comidas Preparadas Mayorista | Alimentos Congelados | Liderdist',
        description: 'Distribuidores mayoristas de comidas preparadas. Soluciones gastronómicas congeladas.'
      },
      "Vegetales Congelados": {
        title: 'Vegetales Congelados Mayorista | Alimentos | Liderdist',
        description: 'Distribuidores mayoristas de vegetales congelados. Productos frescos congelados.'
      },
      "Helados": {
        title: 'Helados Mayorista | Postres Congelados | Liderdist',
        description: 'Distribuidores mayoristas de helados. Postres y helados industriales.'
      },
      "Postres": {
        title: 'Postres Mayorista | Alimentos | Liderdist',
        description: 'Distribuidores mayoristas de postres. Productos frescos y congelados.'
      },
      "Enlatados": {
        title: 'Enlatados Mayorista | Conservas | Liderdist',
        description: 'Distribuidores mayoristas de alimentos enlatados. Conservas de calidad.'
      },
      "Salsas": {
        title: 'Salsas Mayorista | Conservas | Liderdist',
        description: 'Distribuidores mayoristas de salsas. Aderezos y condimentos.'
      },
      "Encurtidos": {
        title: 'Encurtidos Mayorista | Conservas | Liderdist',
        description: 'Distribuidores mayoristas de encurtidos. Vegetales en conserva.'
      },
      "Mermeladas": {
        title: 'Mermeladas Mayorista | Conservas | Liderdist',
        description: 'Distribuidores mayoristas de mermeladas. Dulces y conservas.'
      },
      "Aceite de Oliva": {
        title: 'Aceite de Oliva Mayorista | Aceites | Liderdist',
        description: 'Distribuidores mayoristas de aceite de oliva. Productos premium.'
      },
      "Aceite de Girasol": {
        title: 'Aceite de Girasol Mayorista | Aceites | Liderdist',
        description: 'Distribuidores mayoristas de aceite de girasol. Aceites vegetales.'
      },
      "Aceite de Maíz": {
        title: 'Aceite de Maíz Mayorista | Aceites | Liderdist',
        description: 'Distribuidores mayoristas de aceite de maíz. Aceites vegetales.'
      },
      "Aceite Vegetal": {
        title: 'Aceite Vegetal Mayorista | Aceites | Liderdist',
        description: 'Distribuidores mayoristas de aceite vegetal. Aceites para cocina.'
      },
      "Vinagre de Vino": {
        title: 'Vinagre de Vino Mayorista | Vinagres | Liderdist',
        description: 'Distribuidores mayoristas de vinagre de vino. Condimentos de calidad.'
      },
      "Vinagre Balsámico": {
        title: 'Vinagre Balsámico Mayorista | Vinagres | Liderdist',
        description: 'Distribuidores mayoristas de vinagre balsámico. Condimentos gourmet.'
      },
      "Vinagre de Manzana": {
        title: 'Vinagre de Manzana Mayorista | Vinagres | Liderdist',
        description: 'Distribuidores mayoristas de vinagre de manzana. Condimentos naturales.'
      },
      "Aceto Balsámico": {
        title: 'Aceto Balsámico Mayorista | Vinagres | Liderdist',
        description: 'Distribuidores mayoristas de aceto balsámico. Vinagres premium.'
      },
      "Sal": {
        title: 'Sal Mayorista | Condimentos | Liderdist',
        description: 'Distribuidores mayoristas de sal. Condimentos básicos.'
      },
      "Pimienta": {
        title: 'Pimienta Mayorista | Especias | Liderdist',
        description: 'Distribuidores mayoristas de pimienta. Especias y condimentos.'
      },
      "Condimentos para Carnes": {
        title: 'Condimentos para Carnes Mayorista | Especias | Liderdist',
        description: 'Distribuidores mayoristas de condimentos para carnes. Mezclas especiales.'
      },
      "Especias Enteras": {
        title: 'Especias Enteras Mayorista | Condimentos | Liderdist',
        description: 'Distribuidores mayoristas de especias enteras. Condimentos naturales.'
      },
      "Especias Molidas": {
        title: 'Especias Molidas Mayorista | Condimentos | Liderdist',
        description: 'Distribuidores mayoristas de especias molidas. Condimentos procesados.'
      },
      "Hierbas Aromáticas": {
        title: 'Hierbas Aromáticas Mayorista | Especias | Liderdist',
        description: 'Distribuidores mayoristas de hierbas aromáticas. Condimentos frescos y secos.'
      },
      "Ají Molido": {
        title: 'Ají Molido Mayorista | Especias | Liderdist',
        description: 'Distribuidores mayoristas de ají molido. Condimentos picantes.'
      },
      "Pimentón": {
        title: 'Pimentón Mayorista | Especias | Liderdist',
        description: 'Distribuidores mayoristas de pimentón. Condimentos y colorantes naturales.'
      },
      "Papas Fritas": {
        title: 'Papas Fritas Mayorista | Snacks | Liderdist',
        description: 'Distribuidores mayoristas de papas fritas. Snacks salados.'
      },
      "Maní": {
        title: 'Maní Mayorista | Snacks | Liderdist',
        description: 'Distribuidores mayoristas de maní. Frutos secos y snacks.'
      },
      "Palitos Salados": {
        title: 'Palitos Salados Mayorista | Snacks | Liderdist',
        description: 'Distribuidores mayoristas de palitos salados. Snacks para copetín.'
      },
      "Chocolates": {
        title: 'Chocolates Mayorista | Golosinas | Liderdist',
        description: 'Distribuidores mayoristas de chocolates. Golosinas y confitería.'
      },
      "Caramelos": {
        title: 'Caramelos Mayorista | Golosinas | Liderdist',
        description: 'Distribuidores mayoristas de caramelos. Dulces y golosinas.'
      },
      "Galletitas Dulces": {
        title: 'Galletitas Dulces Mayorista | Golosinas | Liderdist',
        description: 'Distribuidores mayoristas de galletitas dulces. Productos de confitería.'
      },
      "Galletitas Saladas": {
        title: 'Galletitas Saladas Mayorista | Snacks | Liderdist',
        description: 'Distribuidores mayoristas de galletitas saladas. Snacks y copetín.'
      },
      "Chicles": {
        title: 'Chicles Mayorista | Golosinas | Liderdist',
        description: 'Distribuidores mayoristas de chicles. Golosinas y confitería.'
      },

      // Industrial Equipment Categories
      "Máquinas CNC": {
        title: 'Máquinas CNC Mayorista | Equipamiento Industrial | Liderdist',
        description: 'Distribuidores mayoristas de máquinas CNC. Equipamiento de precisión industrial.'
      },
      "Compresores Industriales": {
        title: 'Compresores Industriales Mayorista | Equipos | Liderdist',
        description: 'Distribuidores mayoristas de compresores industriales. Equipamiento neumático.'
      },
      "Tornos": {
        title: 'Tornos Mayorista | Máquinas Herramienta | Liderdist',
        description: 'Distribuidores mayoristas de tornos. Equipamiento para mecanizado.'
      },
      "Fresadoras": {
        title: 'Fresadoras Mayorista | Máquinas Herramienta | Liderdist',
        description: 'Distribuidores mayoristas de fresadoras. Maquinaria de precisión.'
      },
      "Soldadoras": {
        title: 'Soldadoras Mayorista | Equipamiento Industrial | Liderdist',
        description: 'Distribuidores mayoristas de soldadoras. Equipos de soldadura profesional.'
      },
      "Apiladoras": {
        title: 'Apiladoras Mayorista | Equipos de Elevación | Liderdist',
        description: 'Distribuidores mayoristas de apiladoras. Equipamiento para almacenes.'
      },
      "Básculas": {
        title: 'Básculas Mayorista | Equipos de Medición | Liderdist',
        description: 'Distribuidores mayoristas de básculas. Sistemas de pesaje industrial.'
      },

      // Chemical Products Categories
      "Ácidos": {
        title: 'Ácidos Mayorista | Productos Químicos | Liderdist',
        description: 'Distribuidores mayoristas de ácidos. Productos químicos industriales.'
      },
      "Solventes Químicos": {
        title: 'Solventes Químicos Mayorista | Químicos | Liderdist',
        description: 'Distribuidores mayoristas de solventes químicos. Productos para industria.'
      },
      "Productos Químicos Básicos": {
        title: 'Productos Químicos Básicos Mayorista | Químicos | Liderdist',
        description: 'Distribuidores mayoristas de productos químicos básicos. Insumos industriales.'
      },
      "Reactivos": {
        title: 'Reactivos Mayorista | Productos Químicos | Liderdist',
        description: 'Distribuidores mayoristas de reactivos. Químicos para laboratorio.'
      },
      "Material de Laboratorio": {
        title: 'Material de Laboratorio Mayorista | Equipamiento | Liderdist',
        description: 'Distribuidores mayoristas de material de laboratorio. Insumos científicos.'
      },

      // Agricultural Products Categories
      "Fertilizantes": {
        title: 'Fertilizantes Mayorista | Agroquímicos | Liderdist',
        description: 'Distribuidores mayoristas de fertilizantes. Nutrientes para cultivos.'
      },
      "Semillas": {
        title: 'Semillas Mayorista | Agricultura | Liderdist',
        description: 'Distribuidores mayoristas de semillas. Variedades certificadas para cultivo.'
      },
      "Sistemas de Riego": {
        title: 'Sistemas de Riego Mayorista | Agricultura | Liderdist',
        description: 'Distribuidores mayoristas de sistemas de riego. Equipamiento agrícola.'
      },
      "Invernaderos": {
        title: 'Invernaderos Mayorista | Agricultura | Liderdist',
        description: 'Distribuidores mayoristas de invernaderos. Estructuras para cultivos.'
      },
      "Alimento Balanceado": {
        title: 'Alimento Balanceado Mayorista | Ganadería | Liderdist',
        description: 'Distribuidores mayoristas de alimento balanceado. Nutrición animal.'
      },
      "Sanidad Animal": {
        title: 'Sanidad Animal Mayorista | Veterinaria | Liderdist',
        description: 'Distribuidores mayoristas de productos veterinarios. Salud animal.'
      },

      // Packaging Materials Categories
      "Film Stretch": {
        title: 'Film Stretch Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de film stretch. Materiales para embalaje.'
      },
      "Cajas de Cartón": {
        title: 'Cajas de Cartón Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de cajas de cartón. Packaging industrial.'
      },
      "Bolsas": {
        title: 'Bolsas Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de bolsas. Material de empaque.'
      },
      "Cintas Adhesivas": {
        title: 'Cintas Adhesivas Mayorista | Embalajes | Liderdist',
        description: 'Distribuidores mayoristas de cintas adhesivas. Materiales de embalaje.'
      },
      "Pallets": {
        title: 'Pallets Mayorista | Logística | Liderdist',
        description: 'Distribuidores mayoristas de pallets. Equipamiento para almacenaje.'
      },

      // Electronics and Technology Categories
      "Celulares y Tablets": {
        title: 'Celulares y Tablets Mayorista | Tecnología | Liderdist',
        description: 'Distribuidores mayoristas de celulares y tablets. Dispositivos móviles.'
      },
      "Computadoras": {
        title: 'Computadoras Mayorista | Informática | Liderdist',
        description: 'Distribuidores mayoristas de computadoras. Equipos informáticos.'
      },
      "Notebooks": {
        title: 'Notebooks Mayorista | Informática | Liderdist',
        description: 'Distribuidores mayoristas de notebooks. Computadoras portátiles.'
      },
      "Impresoras": {
        title: 'Impresoras Mayorista | Informática | Liderdist',
        description: 'Distribuidores mayoristas de impresoras. Equipos de impresión.'
      },
      "Monitores": {
        title: 'Monitores Mayorista | Informática | Liderdist',
        description: 'Distribuidores mayoristas de monitores. Pantallas profesionales.'
      },

      // Safety Equipment Categories
      "Equipos de Protección": {
        title: 'Equipos de Protección Mayorista | Seguridad Industrial | Liderdist',
        description: 'Distribuidores mayoristas de equipos de protección personal. Seguridad laboral.'
      },
      "Cascos de Seguridad": {
        title: 'Cascos de Seguridad Mayorista | EPP | Liderdist',
        description: 'Distribuidores mayoristas de cascos de seguridad. Protección industrial.'
      },
      "Guantes de Trabajo": {
        title: 'Guantes de Trabajo Mayorista | EPP | Liderdist',
        description: 'Distribuidores mayoristas de guantes de trabajo. Protección para manos.'
      },
      "Calzado de Seguridad": {
        title: 'Calzado de Seguridad Mayorista | EPP | Liderdist',
        description: 'Distribuidores mayoristas de calzado de seguridad. Protección para pies.'
      },
      "Protección Auditiva": {
        title: 'Protección Auditiva Mayorista | EPP | Liderdist',
        description: 'Distribuidores mayoristas de protección auditiva. Seguridad industrial.'
      },
      "Protección Ocular": {
        title: 'Protección Ocular Mayorista | EPP | Liderdist',
        description: 'Distribuidores mayoristas de protección ocular. Gafas de seguridad.'
      },

      // Textile Categories
      "Telas": {
        title: 'Telas Mayorista | Textil | Liderdist',
        description: 'Distribuidores mayoristas de telas. Materiales textiles industriales.'
      },
      "Hilados": {
        title: 'Hilados Mayorista | Textil | Liderdist',
        description: 'Distribuidores mayoristas de hilados. Insumos para industria textil.'
      },
      "Accesorios Textiles": {
        title: 'Accesorios Textiles Mayorista | Mercería | Liderdist',
        description: 'Distribuidores mayoristas de accesorios textiles. Insumos de mercería.'
      },
      "Telas Sintéticas": {
        title: 'Telas Sintéticas Mayorista | Textil | Liderdist',
        description: 'Distribuidores mayoristas de telas sintéticas. Materiales modernos.'
      },
      "Telas de Algodón": {
        title: 'Telas de Algodón Mayorista | Textil | Liderdist',
        description: 'Distribuidores mayoristas de telas de algodón. Materiales naturales.'
      },

      // Medical Supplies Categories
      "Insumos Médicos": {
        title: 'Insumos Médicos Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de insumos médicos. Equipamiento hospitalario.'
      },
      "Equipamiento Médico": {
        title: 'Equipamiento Médico Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de equipamiento médico. Tecnología médica.'
      },
      "Productos Descartables": {
        title: 'Productos Descartables Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de productos descartables médicos. Insumos hospitalarios.'
      },
      "Instrumental Quirúrgico": {
        title: 'Instrumental Quirúrgico Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de instrumental quirúrgico. Herramientas médicas.'
      },
      "Diagnóstico por Imágenes": {
        title: 'Diagnóstico por Imágenes Mayorista | Medicina | Liderdist',
        description: 'Distribuidores mayoristas de equipos de diagnóstico. Tecnología médica avanzada.'
      },

      // Construction Materials Categories
      "Materiales de Construcción": {
        title: 'Materiales de Construcción Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de materiales de construcción. Insumos para obras.'
      },
      "Cemento": {
        title: 'Cemento Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de cemento. Materiales básicos de construcción.'
      },
      "Arena y Piedra": {
        title: 'Arena y Piedra Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de arena y piedra. Áridos para construcción.'
      },
      "Hierros": {
        title: 'Hierros Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de hierros. Materiales estructurales.'
      },
      "Ladrillos": {
        title: 'Ladrillos Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de ladrillos. Materiales para mampostería.'
      },
      "Pinturas": {
        title: 'Pinturas Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de pinturas. Revestimientos y acabados.'
      },
      "Herramientas de Construcción": {
        title: 'Herramientas de Construcción Mayorista | Construcción | Liderdist',
        description: 'Distribuidores mayoristas de herramientas. Equipamiento para construcción.'
      },

      // Automotive Parts Categories
      "Repuestos Automotores": {
        title: 'Repuestos Automotores Mayorista | Autopartes | Liderdist',
        description: 'Distribuidores mayoristas de repuestos automotores. Piezas originales y alternativas.'
      },
      "Aceites y Lubricantes": {
        title: 'Aceites y Lubricantes Mayorista | Automotor | Liderdist',
        description: 'Distribuidores mayoristas de aceites y lubricantes. Productos para vehículos.'
      },
      "Filtros": {
        title: 'Filtros Mayorista | Autopartes | Liderdist',
        description: 'Distribuidores mayoristas de filtros automotores. Repuestos de calidad.'
      },
      "Baterías": {
        title: 'Baterías Mayorista | Autopartes | Liderdist',
        description: 'Distribuidores mayoristas de baterías. Energía para vehículos.'
      },
      "Neumáticos": {
        title: 'Neumáticos Mayorista | Autopartes | Liderdist',
        description: 'Distribuidores mayoristas de neumáticos. Cubiertas para todo tipo de vehículos.'
      },

      // Plumbing and Electrical Categories
      "Materiales Eléctricos": {
        title: 'Materiales Eléctricos Mayorista | Electricidad | Liderdist',
        description: 'Distribuidores mayoristas de materiales eléctricos. Insumos profesionales.'
      },
      "Cables": {
        title: 'Cables Mayorista | Electricidad | Liderdist',
        description: 'Distribuidores mayoristas de cables eléctricos. Conductores de calidad.'
      },
      "Tableros Eléctricos": {
        title: 'Tableros Eléctricos Mayorista | Electricidad | Liderdist',
        description: 'Distribuidores mayoristas de tableros eléctricos. Equipamiento profesional.'
      },
      "Iluminación": {
        title: 'Iluminación Mayorista | Electricidad | Liderdist',
        description: 'Distribuidores mayoristas de iluminación. Soluciones LED y tradicionales.'
      },
      "Cañerías": {
        title: 'Cañerías Mayorista | Plomería | Liderdist',
        description: 'Distribuidores mayoristas de cañerías. Sistemas de conducción.'
      },
      "Bombas de Agua": {
        title: 'Bombas de Agua Mayorista | Plomería | Liderdist',
        description: 'Distribuidores mayoristas de bombas de agua. Equipos de presión.'
      },

      // Office Supplies Categories
      "Artículos de Oficina": {
        title: 'Artículos de Oficina Mayorista | Papelería | Liderdist',
        description: 'Distribuidores mayoristas de artículos de oficina. Insumos empresariales.'
      },
      "Papel": {
        title: 'Papel Mayorista | Papelería | Liderdist',
        description: 'Distribuidores mayoristas de papel. Resmas y productos de papel.'
      },
      "Útiles Escolares": {
        title: 'Útiles Escolares Mayorista | Papelería | Liderdist',
        description: 'Distribuidores mayoristas de útiles escolares. Material educativo.'
      },
      "Mobiliario de Oficina": {
        title: 'Mobiliario de Oficina Mayorista | Muebles | Liderdist',
        description: 'Distribuidores mayoristas de mobiliario de oficina. Equipamiento profesional.'
      },

      // Sports Equipment Categories
      "Equipamiento Deportivo": {
        title: 'Equipamiento Deportivo Mayorista | Deportes | Liderdist',
        description: 'Distribuidores mayoristas de equipamiento deportivo. Material profesional.'
      },
      "Máquinas de Gimnasio": {
        title: 'Máquinas de Gimnasio Mayorista | Fitness | Liderdist',
        description: 'Distribuidores mayoristas de máquinas de gimnasio. Equipamiento profesional.'
      },
      "Pelotas y Balones": {
        title: 'Pelotas y Balones Mayorista | Deportes | Liderdist',
        description: 'Distribuidores mayoristas de pelotas y balones. Equipamiento deportivo.'
      },
      "Accesorios Deportivos": {
        title: 'Accesorios Deportivos Mayorista | Deportes | Liderdist',
        description: 'Distribuidores mayoristas de accesorios deportivos. Complementos deportivos.'
      },
      "Indumentaria Deportiva": {
        title: 'Indumentaria Deportiva Mayorista | Deportes | Liderdist',
        description: 'Distribuidores mayoristas de indumentaria deportiva. Ropa técnica.'
      },
      "Calzado Deportivo": {
        title: 'Calzado Deportivo Mayorista | Deportes | Liderdist',
        description: 'Distribuidores mayoristas de calzado deportivo. Zapatillas especializadas.'
      },

      // Pet Supplies Categories
      "Alimentos para Mascotas": {
        title: 'Alimentos para Mascotas Mayorista | Pet Shop | Liderdist',
        description: 'Distribuidores mayoristas de alimentos para mascotas. Nutrición animal.'
      },
      "Accesorios para Mascotas": {
        title: 'Accesorios para Mascotas Mayorista | Pet Shop | Liderdist',
        description: 'Distribuidores mayoristas de accesorios para mascotas. Productos para animales.'
      },
      "Higiene para Mascotas": {
        title: 'Higiene para Mascotas Mayorista | Pet Shop | Liderdist',
        description: 'Distribuidores mayoristas de productos de higiene para mascotas. Cuidado animal.'
      },

      // Beauty and Personal Care Categories
      "Cosméticos": {
        title: 'Cosméticos Mayorista | Belleza | Liderdist',
        description: 'Distribuidores mayoristas de cosméticos. Productos de belleza profesionales.'
      },
      "Perfumes": {
        title: 'Perfumes Mayorista | Fragancias | Liderdist',
        description: 'Distribuidores mayoristas de perfumes. Fragancias importadas y nacionales.'
      },
      "Productos Capilares": {
        title: 'Productos Capilares Mayorista | Peluquería | Liderdist',
        description: 'Distribuidores mayoristas de productos capilares. Cuidado del cabello.'
      },
      "Cuidado Personal": {
        title: 'Cuidado Personal Mayorista | Higiene | Liderdist',
        description: 'Distribuidores mayoristas de productos de cuidado personal. Higiene y belleza.'
      },

      // Toys and Games Categories
      "Juguetes": {
        title: 'Juguetes Mayorista | Juegos | Liderdist',
        description: 'Distribuidores mayoristas de juguetes. Productos para niños.'
      },
      "Juegos de Mesa": {
        title: 'Juegos de Mesa Mayorista | Entretenimiento | Liderdist',
        description: 'Distribuidores mayoristas de juegos de mesa. Entretenimiento familiar.'
      },
      "Juguetes Educativos": {
        title: 'Juguetes Educativos Mayorista | Didácticos | Liderdist',
        description: 'Distribuidores mayoristas de juguetes educativos. Material didáctico.'
      },

      // Cleaning Supplies Categories
      "Productos de Limpieza": {
        title: 'Productos de Limpieza Mayorista | Limpieza | Liderdist',
        description: 'Distribuidores mayoristas de productos de limpieza. Insumos profesionales.'
      },
      "Detergentes": {
        title: 'Detergentes Mayorista | Limpieza | Liderdist',
        description: 'Distribuidores mayoristas de detergentes. Productos de lavado.'
      },
      "Desinfectantes": {
        title: 'Desinfectantes Mayorista | Limpieza | Liderdist',
        description: 'Distribuidores mayoristas de desinfectantes. Productos de sanitización.'
      },

      // Garden and Outdoor Categories
      "Herramientas de Jardinería": {
        title: 'Herramientas de Jardinería Mayorista | Jardín | Liderdist',
        description: 'Distribuidores mayoristas de herramientas de jardinería. Equipamiento profesional.'
      },
      "Plantas y Semillas": {
        title: 'Plantas y Semillas Mayorista | Jardinería | Liderdist',
        description: 'Distribuidores mayoristas de plantas y semillas. Productos para jardín.'
      },
      "Fertilizantes de Jardín": {
        title: 'Fertilizantes de Jardín Mayorista | Jardinería | Liderdist',
        description: 'Distribuidores mayoristas de fertilizantes de jardín. Nutrientes para plantas.'
      },

      // Art and Craft Supplies
      "Materiales de Arte": {
        title: 'Materiales de Arte Mayorista | Arte | Liderdist',
        description: 'Distribuidores mayoristas de materiales de arte. Insumos para artistas.'
      },
      "Pinturas Artísticas": {
        title: 'Pinturas Artísticas Mayorista | Arte | Liderdist',
        description: 'Distribuidores mayoristas de pinturas artísticas. Materiales profesionales.'
      },
      "Material de Manualidades": {
        title: 'Material de Manualidades Mayorista | Arte | Liderdist',
        description: 'Distribuidores mayoristas de material de manualidades. Insumos creativos.'
      },

      // Music and Instruments
      "Instrumentos Musicales": {
        title: 'Instrumentos Musicales Mayorista | Música | Liderdist',
        description: 'Distribuidores mayoristas de instrumentos musicales. Equipamiento profesional.'
      },
      "Accesorios Musicales": {
        title: 'Accesorios Musicales Mayorista | Música | Liderdist',
        description: 'Distribuidores mayoristas de accesorios musicales. Complementos para músicos.'
      },
      "Equipos de Sonido": {
        title: 'Equipos de Sonido Mayorista | Audio | Liderdist',
        description: 'Distribuidores mayoristas de equipos de sonido. Sistemas profesionales.'
      }
    };

    // If it's a main category and we have specific mapping
    if (categoryMappings[category]) {
      return categoryMappings[category];
    }

    // Generate dynamic SEO data for subcategories or unmapped categories
    const categoryName = isSubcategory ? 
      `${category} - ${CATEGORY_HIERARCHY[parentCategory].name}` : 
      category;

    return {
      title: `${categoryName} Mayorista | Distribuidores de ${category} | Liderdist`,
      description: `Encuentra los mejores distribuidores mayoristas de ${category.toLowerCase()} en Argentina. Precios directos de fábrica sin comisiones. Proveedores verificados.`
    };
  };

  const seoData = getSEOData(category);

  // Create structured data for category pages
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": category ? `${category} Mayorista` : "Productos Mayoristas",
    "description": seoData.description,
    "provider": {
      "@type": "Organization",
      "name": "Liderdist",
      "url": "https://www.liderdist.com"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Inicio",
          "item": "https://www.liderdist.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Productos",
          "item": "https://www.liderdist.com/s"
        },
        ...(category ? [{
          "@type": "ListItem",
          "position": 3,
          "name": category,
          "item": `https://www.liderdist.com/s?category=${encodeURIComponent(category)}`
        }] : [])
      ]
    }
  };

  // Get the current sort values from filterInputs or URL params
  const currentSortValue = `${searchParams.get('sortBy') || 'createdAt'}-${searchParams.get('sortOrder') || 'desc'}`;

  // Handler for sort changes
  const handleSortChange = (value) => {
    const [sortBy, sortOrder] = value.split('-');
    const newParams = new URLSearchParams(searchParams);
    newParams.set('sortBy', sortBy);
    newParams.set('sortOrder', sortOrder);
    setSearchParams(newParams);
  };

  // Add this useEffect right after your state declarations
  useEffect(() => {
    // Sync filter inputs with URL params on load and when URL changes
    setFilterInputs(prev => ({
      ...prev,
      search: searchParams.get('search') || '',
      category: searchParams.get('category') || '',
      location: searchParams.get('location') || '',
      priceRange: {
        min: searchParams.get('minPrice') || '',
        max: searchParams.get('maxPrice') || ''
      },
      stockRange: {
        min: searchParams.get('minStock') || '',
        max: searchParams.get('maxStock') || ''
      },
      showWithStock: searchParams.get('inStock') === 'true',
      showWithPrice: searchParams.get('hidePrice') === 'false',
      verifiedDistributors: searchParams.get('verifiedDistributor') === 'true',
      province: searchParams.get('province') || '',
      city: searchParams.get('city') || '',
    }));

    // Update category selections based on URL
    const categoryParam = searchParams.get('category');
    if (categoryParam) {
      const path = getCategoryPath(categoryParam);
      setSelectedMainCategory(path[0]);
      setSelectedSubCategory(path.length > 1 ? path[1] : null);
    } else {
      setSelectedMainCategory(null);
      setSelectedSubCategory(null);
    }

  }, [searchParams]);

  return (
    <>
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <link rel="canonical" href={`https://www.liderdist.com/s${category ? `?category=${encodeURIComponent(category)}` : ''}`} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:url" content={`https://www.liderdist.com/s${category ? `?category=${encodeURIComponent(category)}` : ''}`} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Banner only shows when there are no filters */}
      {!hasActiveFilters(searchParams) && !isMobile && (
        <Box
          sx={{
            width: '100vw',
            position: 'relative',
            left: '50%',
            right: '50%',
            marginLeft: '-50vw',
            marginRight: '-50vw',
            marginBottom: 0,
            backgroundColor: '#ff5833',
            minHeight: '200px',
          }}
        >
          <img
            src={banner}
            alt="Liderdist Banner"
            loading="eager"
            fetchpriority="high"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              objectFit: 'cover'
            }}
          />
        </Box>
      )}

      {/* Filter Bar for Mobile */}
      {isMobile && (
        <FilterBar>
          <Typography variant="body1"
            sx={{
              color: '#282828',
              fontSize: '0.95rem'
              }}>
              Filtros</Typography>
          <IconButton onClick={() => setFilterMenuOpen(!filterMenuOpen)}>
            {filterMenuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </FilterBar>
      )}

      {/* Sort Bar for Mobile */}
      {isMobile && (
        <>
        <SortBar>
          <Typography variant="body1"
          sx={{
            color: 'white',
            fontSize: '0.95rem'
            }}
          >Ordenar por</Typography>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              sx={{
                color: 'white',
                  "& .MuiSelect-icon": {
                color: "#ffffff"},
                        "& .MuiOutlinedInput-notchedOutline": {
                  border: "none", // Remove the border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none", // Ensure no border on hover
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none", // Ensure no border when focused
                },
                        // Arrow (dropdown indicator) color
                fontSize: '0.95rem',
              }}
              value={`${searchParams.get('sortBy') || 'createdAt'}-${searchParams.get('sortOrder') || 'desc'}`}
              onChange={(e) => {
                const [sortBy, sortOrder] = e.target.value.split('-');
                const newParams = new URLSearchParams(searchParams);
                newParams.set('sortBy', sortBy);
                newParams.set('sortOrder', sortOrder);
                setSearchParams(newParams);
              }}
            >
              <MenuItem value="createdAt-desc">Más recientes</MenuItem>
              <MenuItem value="createdAt-asc">Más antiguos</MenuItem>
              <MenuItem value="basePrice-asc">Menor precio</MenuItem>
              <MenuItem value="basePrice-desc">Mayor precio</MenuItem>
              <MenuItem value="name-asc">Nombre A-Z</MenuItem>
              <MenuItem value="name-desc">Nombre Z-A</MenuItem>
            </Select>
          </FormControl>
        </SortBar>
        </>
      )}

      {/* Products section with its own loading state */}
      {productsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <Box sx={{
            px: isMobile ? '0' : {
              sm: '1%',
              md: '2%',
              mdl: '5%',
              lg: '10%',
            },
            backgroundColor: theme.palette.background.default

          }}>
            <Container maxWidth="xl" sx={{ px:0,pb: 4 }}>
              {isMobile && <QuickAccessToolbar 
          filterInputs={filterInputs}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setFilterInputs={setFilterInputs}
        />}
              {!isMobile && <Box sx={{
                    p:1,
                    m:{xs:0,md:1},
                  }}>
                  <Typography variant='h5' sx={{
                    fontSize: '1.2rem',
                    pl:{xs:1,md:0},
                    width: {xs: '95vw', md: 'auto'},
                    
                  }}>
                    {searchParams.get('search') ? searchParams.get('search') : (
                      searchParams.get('category') ? (
                        getCategoryPath(searchParams.get('category'))
                          .map((cat, index, array) => (
                            <React.Fragment key={cat}>
                            <Box
                              component="span"
                              onClick={() => {
                                // Create new URLSearchParams from current params
                                const newParams = new URLSearchParams(searchParams);
                                // Update category parameter
                                newParams.set('category', cat);
                                // Reset to page 1 when changing category
                                newParams.set('page', '1');
                                // Update URL params which will trigger the fetch
                                setSearchParams(newParams);
                              }}
                              sx={{
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline'
                                },
                                fontSize: '1.1rem'
                              }}
                            >
                              {CATEGORY_HIERARCHY[cat]?.name || cat}
                            </Box>
                            {index < array.length - 1 && (
                              <Box component="span" sx={{ mx: 1, color: 'gray', fontSize: '1.1rem' }}>
                                {">"}
                              </Box>
                            )}
                          </React.Fragment>
                        ))
                    ) : (
                      "Todas las categorías"
                    ))}
                  </Typography>
                  <Typography sx={{
                    color: 'text.secondary',
                    width: {xs: '95vw', md: 'auto'},
                    pl:{xs:1,md:0}
                  }} variant="body2" color="text.secondary">
                    {paginationData.totalProducts} {paginationData.totalProducts === 1 ? 'producto encontrado' : 'productos encontrados'}
                  </Typography>
                  </Box>}

              {!isMobile && <QuickAccessToolbar 
          filterInputs={filterInputs}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setFilterInputs={setFilterInputs}
        />}

              <Grid container spacing={{xs:0,md:2}}>
                {/* Filters Section */}
                <Grid item xs={12} md={3}>
                  {/* Collapsible Filter Content */}
                  <Collapse in={!isMobile || filterMenuOpen}>
                    <Paper sx={{ p: 2, mb: 2 }}>
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 2
                      }}>
                        {!isMobile && <Typography variant="h6">Filtros</Typography>}
                        <Button
                          size="small"
                          startIcon={<DeleteSweepIcon />}
                          onClick={resetFilters}
                          sx={{
                            color: 'text.secondary',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                            fontSize: '0.875rem'
                          }}
                        >
                          Limpiar
                        </Button>
                        {!isMobile && 
                        <Button
                          size="small"
                          startIcon={<SearchIcon />}
                          onClick={handleApplyFilters}
                          sx={{
                            color: 'text.secondary',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                            fontSize: '0.875rem'
                          }}
                        >
                          Buscar
                        </Button>
                        }
                      </Box>

                      {/* Price Range Filter */}
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Rango de Precio</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              size="small"
                              type="number"
                              label="Min"
                              value={filterInputs.priceRange.min}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                priceRange: { ...prev.priceRange, min: e.target.value }
                              }))}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              size="small"
                              type="number"
                              label="Max"
                              value={filterInputs.priceRange.max}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                priceRange: { ...prev.priceRange, max: e.target.value }
                              }))}
                            />
                          </Grid>
                        </Grid>
                      </Box>

                       {/* Province Filter */}
                       <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Provincia</Typography>
                        <FormControl fullWidth size="small">
                          <Select
                            value={filterInputs.province}
                            onChange={(e) => {
                              const selectedProvince = e.target.value;
                              setFilterInputs(prev => ({
                                ...prev,
                                province: selectedProvince,
                                city: '' // Reset city when province changes
                              }));
                            }}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Todas las provincias</em>
                            </MenuItem>
                            {getProvinces('AR').map((province) => ( // Use getProvinces to get provinces for Argentina
                              <MenuItem key={province} value={province}>
                                {province}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>

                      {/* City Filter */}
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Ciudad</Typography>
                        <FormControl fullWidth size="small">
                          <Select
                            value={filterInputs.city}
                            onChange={(e) => setFilterInputs(prev => ({ ...prev, city: e.target.value }))}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Todas las ciudades</em>
                            </MenuItem>
                            {filterInputs.province ? getCities('AR', filterInputs.province).map((city) => (
                              <MenuItem key={city} value={city}>
                                {city}
                              </MenuItem>
                            )) : ['Ingrese una provincia para filtrar por ciudad']}
                          </Select>
                        </FormControl>
                      </Box>


                      {/* Location Filter */}
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Zona de Envío</Typography>
                        <FormControl fullWidth size="small">
                          <Select
                            value={filterInputs.location}
                            onChange={(e) => setFilterInputs(prev => ({ ...prev, location: e.target.value }))}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>Todas las zonas</em>
                            </MenuItem>
                            {predefinedZones.map((zone) => (
                              <MenuItem key={zone} value={zone}>
                                {zone}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>

                      {/* Price and Stock Visibility */}
                      <Box sx={{ mb: 3 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={filterInputs.showWithPrice}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                showWithPrice: e.target.checked
                              }))}
                              size="small"
                            />
                          }
                          label={<Typography variant="body2">Mostrar solo productos con precio visible</Typography>}
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={filterInputs.showWithStock}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                showWithStock: e.target.checked
                              }))}
                              size="small"
                            />
                          }
                          label={<Typography variant="body2">Mostrar solo productos con stock</Typography>}
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={filterInputs.verifiedDistributors}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                verifiedDistributors: e.target.checked
                              }))}
                              size="small"
                            />
                          }
                          label={<Typography variant="body2">Solo distribuidores verificados</Typography>}
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }}
                        />
                      </Box>

                      {/* Stock Range */}
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Rango de Stock</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              size="small"
                              type="number"
                              label="Min"
                              value={filterInputs.stockRange.min}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                stockRange: { ...prev.stockRange, min: e.target.value }
                              }))}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              size="small"
                              type="number"
                              label="Max"
                              value={filterInputs.stockRange.max}
                              onChange={(e) => setFilterInputs(prev => ({
                                ...prev,
                                stockRange: { ...prev.stockRange, max: e.target.value }
                              }))}
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      {/* Category Filter */}
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Categoría</Typography>

                        <List dense>
                          {Object.keys(CATEGORY_HIERARCHY).map((category) => (
                            <React.Fragment key={category}>
                              {/* Main category */}
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: selectedMainCategory === category ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
                                }}
                              >
                                <ListItemButton
                                  onClick={() => {
                                    selectedMainCategory === category ? setSelectedMainCategory(null) : setSelectedMainCategory(category);
                                    setSelectedSubCategory(null);
                                    setFilterInputs(prev => ({ ...prev, category }));
                                  }}
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    backgroundColor: selectedMainCategory === category ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
                                  }}
                                >
                                  <ListItemText
                                    primary={CATEGORY_HIERARCHY[category].name}
                                    primaryTypographyProps={{
                                      fontSize: '0.9rem',
                                      fontWeight: selectedMainCategory === category ? 'bold' : 'normal'
                                    }}
                                  />
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      filterInputs.category = category;
                                      handleApplyFilters();
                                      // const newParams = new URLSearchParams(searchParams);
                                      // newParams.set('category', category);
                                      // newParams.set('page', '1');
                                      // setSearchParams(newParams);
                                    }}
                                    sx={{
                                      visibility: selectedMainCategory === category ? 'visible' : 'hidden',
                                      '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                      }
                                    }}
                                  >
                                    <SearchIcon fontSize="small" />
                                  </IconButton>
                                </ListItemButton>
                              </ListItem>

                              {/* Subcategories - show immediately after parent if selected */}
                              {selectedMainCategory === category && (
                                <List dense sx={{ pl: 2 }}>
                                  {getSubcategories(selectedMainCategory).map((subCategory) => (
                                    <React.Fragment key={subCategory}>
                                      <ListItem
                                        disablePadding
                                        sx={{
                                          backgroundColor: selectedSubCategory === subCategory ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
                                        }}
                                      >
                                        <ListItemButton
                                          onClick={() => {
                                            selectedSubCategory === subCategory ? setSelectedSubCategory(null) : setSelectedSubCategory(subCategory);
                                            setFilterInputs(prev => ({ ...prev, category: subCategory }));
                                          }}
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            backgroundColor: selectedSubCategory === subCategory ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
                                          }}
                                        >
                                          <ListItemText
                                            primary={subCategory}
                                            primaryTypographyProps={{
                                              fontSize: '0.85rem',
                                              fontWeight: selectedSubCategory === subCategory ? 'bold' : 'normal'
                                            }}
                                          />
                                          <IconButton
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              filterInputs.category = subCategory;
                                              handleApplyFilters();
                                              // const newParams = new URLSearchParams(searchParams);
                                              // newParams.set('category', subCategory);
                                              // newParams.set('page', '1');
                                              // setSearchParams(newParams);
                                            }}
                                            sx={{
                                              visibility: selectedSubCategory === subCategory ? 'visible' : 'hidden',
                                              '&:hover': {
                                                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                              }
                                            }}
                                          >
                                            <SearchIcon fontSize="small" />
                                          </IconButton>
                                        </ListItemButton>
                                      </ListItem>

                                      {/* Leaf categories - show immediately after parent if selected */}
                                      {selectedSubCategory === subCategory && (
                                        <List dense sx={{ pl: 2 }}>
                                          {getLeafCategories(selectedMainCategory, selectedSubCategory).map((leafCategory) => (
                                            <ListItem
                                              key={leafCategory}
                                              disablePadding
                                              sx={{
                                                backgroundColor: filterInputs.category === leafCategory ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
                                              }}
                                            >
                                              <ListItemButton
                                                onClick={() => {
                                                  setFilterInputs(prev => ({ ...prev, category: leafCategory }));
                                                }}
                                                sx={{
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  backgroundColor: filterInputs.category === leafCategory ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
                                                }}
                                              >
                                                <ListItemText
                                                  primary={leafCategory}
                                                  primaryTypographyProps={{
                                                    fontSize: '0.8rem',
                                                    fontWeight: filterInputs.category === leafCategory ? 'bold' : 'normal'
                                                  }}
                                                />
                                                <IconButton
                                                  size="small"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    filterInputs.category = leafCategory;
                                                    handleApplyFilters();
                                                    // const newParams = new URLSearchParams(searchParams);
                                                    // newParams.set('category', leafCategory);
                                                    // newParams.set('page', '1');
                                                    // setSearchParams(newParams);
                                                  }}
                                                  sx={{
                                                    visibility: filterInputs.category === leafCategory ? 'visible' : 'hidden',
                                                    '&:hover': {
                                                      backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                                    }
                                                  }}
                                                >
                                                  <SearchIcon fontSize="small" />
                                                </IconButton>
                                              </ListItemButton>
                                            </ListItem>
                                          ))}
                                        </List>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </List>
                              )}
                            </React.Fragment>
                          ))}
                        </List>
                      </Box>

              
                      {/* Apply Filters Button */}
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => {
                          handleApplyFilters();
                          if (isMobile) setFilterMenuOpen(false); // Close filter menu after applying on mobile
                        }}
                        sx={{ mt: 2 }}
                      >
                        Buscar
                      </Button>
                      {isMobile && (
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        width: '100%',
                        pt: 3
                      }}
                      onClick={() => setFilterMenuOpen(!filterMenuOpen)}
                    >
                    
                      <IconButton size="small">
                          <ExpandLessIcon sx={{ fontSize: 35 }} />
                         
                      </IconButton>
                    </Box>
                  )}
                  

                      {/* Keep your existing category filters here */}
                    </Paper>
                    
                  </Collapse>

                  
                  {isMobile && <Box sx={{
                    px:0.5,
                    backgroundColor: 'background.paper', 
                    height: 'auto',
                    py:1
                  }}>
                  <Typography variant='h5' sx={{
                    fontSize: '0.9rem',
                    pl:{xs:1,md:0},
                    width: {xs: '95vw',sm: 'auto', md: 'auto'},
                    
                  }}>
                    {searchParams.get('search') ? searchParams.get('search') : (
                      searchParams.get('category') ? (
                        getCategoryPath(searchParams.get('category'))
                          .map((cat, index, array) => (
                            <React.Fragment key={cat}>
                            <Box
                              component="span"
                              onClick={() => {
                                // Create new URLSearchParams from current params
                                const newParams = new URLSearchParams(searchParams);
                                // Update category parameter
                                newParams.set('category', cat);
                                // Reset to page 1 when changing category
                                newParams.set('page', '1');
                                // Update URL params which will trigger the fetch
                                setSearchParams(newParams);
                              }}
                              sx={{
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              {CATEGORY_HIERARCHY[cat]?.name || cat}
                            </Box>
                            {index < array.length - 1 && (
                              <Box component="span" sx={{ mx: 1, color: 'text.secondary' }}>
                                {">"}
                              </Box>
                            )}
                          </React.Fragment>
                        ))
                    ) : (
                      "Todas las categorías"
                    ))}
                  </Typography>
                  <Typography sx={{
                    color: 'text.secondary',
                    width: {xs: '95vw', md: 'auto'},
                    pl:{xs:1,md:0}
                  }} variant="body2" color="text.secondary">
                    {paginationData.totalProducts} productos encontrados
                  </Typography>
                  </Box>}
                </Grid>

                {/* Products Grid */}
                <Grid item xs={12} md={9}>
                <FeaturedProductsSlideshow products={featuredProducts} />
                    

                  <Grid container sx={{
                    mt: {xs:0,sm:featuredProducts.length > 0 ? 2 : -1}
                }}
                  spacing={{xs:0,sm:1,md:1}}>
                    {products.map((product) => (
                      <Grid item key={product._id} xs={12} sm={4} md={4} lg={3}>
                        <ProductCard product={product} />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              <Typography variant="h5" sx={{ color: '#282828', fontFamily: 'Roboto', fontSize: '1rem', m:2 }}>
            Te podría interesar:
          </Typography>
              <EyeCatcher />

              {/* Pagination */}
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                mt: 4
              }}>
                <Pagination
                  count={paginationData.totalPages}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '1rem',
                    },
                    '& .Mui-selected': {
                      backgroundColor: 'primary.main',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                      },
                    },
                  }}
                />
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Mostrando página {page} de {paginationData.totalPages}
                  ({paginationData.totalProducts} productos en total)
                </Typography>
              </Box>
            </Container>
          </Box>
        </>
      )}
    </>
  );
};

export default LandingPage;
